module.exports = __webpack_public_path__ + "img/ctech-logo-final-white.311fcef7.svg";